export const fields =  [
    {
        "id": "arhl",
        "title": "ARHL",
        "questions": [
            {
                "id": "arhlPlotting",
                "type": "dropdown",
                "title": "ARHL (Centile) Plotting",
                "options": [
                    {
                        "id": "1",
                        "title": "ENT Match"
                    },
                    {
                        "id": "2",
                        "title": "Use Bulge"
                    },
                    {
                        "id": "3",
                        "title": "User Defined"
                    }
                ],
                "required": false
            },
            {
                "id": "arhlParam",
                "type": "dropdown",
                "title": "Bulge Calculation Data",
                "options": [
                    {
                        "id": "1",
                        "title": "Best Fit"
                    },
                    {
                        "id": "2",
                        "title": "ARHL Match"
                    },
                    {
                        "id": "3",
                        "title": "User Defined"
                    }
                ],
                "required": false
            }
        ]
    },
    {
        "id": "ageCentile",
        "title": "Age & Centile",
        "questions": [
            {
                "id": "changeAgeTo",
                "type": "dropdown",
                "title": "Change Age To",
                "options": [
                    {
                        "id": 20,
                        "title": 20
                    },
                    {
                        "id": 25,
                        "title": 25
                    },
                    {
                        "id": 30,
                        "title": 30
                    },
                    {
                        "id": 35,
                        "title": 35
                    },
                    {
                        "id": 40,
                        "title": 40
                    },
                    {
                        "id": 45,
                        "title": 45
                    },
                    {
                        "id": 50,
                        "title": 50
                    },
                    {
                        "id": 55,
                        "title": 55
                    },
                    {
                        "id": 60,
                        "title": 60
                    },
                    {
                        "id": 65,
                        "title": 65
                    },
                    {
                        "id": 70,
                        "title": 70
                    },
                    {
                        "id": 75,
                        "title": 75
                    },
                    {
                        "id": 80,
                        "title": 80
                    }
                ],
                "required": false
            },
            {
                "id": "changeCentileTo",
                "type": "number",
                "title": "Change Centile To",
                "required": false,
                "validation": {
                    "max": 95,
                    "min": 5
                }
            }
        ]
    },
    {
        "id": "anchor",
        "title": "Anchor",
        "questions": [
            {
                "id": "newDbValue",
                "type": "dropdown",
                "title": "Notional dB(A) LEP’D Level exposed",
                "options": [
                    {
                        "id": 85,
                        "title": 85
                    },
                    {
                        "id": 86,
                        "title": 86
                    },
                    {
                        "id": 87,
                        "title": 87
                    },
                    {
                        "id": 88,
                        "title": 88
                    },
                    {
                        "id": 89,
                        "title": 89
                    },
                    {
                        "id": 90,
                        "title": 90
                    },
                    {
                        "id": 91,
                        "title": 91
                    },
                    {
                        "id": 92,
                        "title": 92
                    },
                    {
                        "id": 93,
                        "title": 93
                    },
                    {
                        "id": 94,
                        "title": 94
                    },
                    {
                        "id": 95,
                        "title": 95
                    },
                    {
                        "id": 96,
                        "title": 96
                    },
                    {
                        "id": 97,
                        "title": 97
                    },
                    {
                        "id": 98,
                        "title": 98
                    },
                    {
                        "id": 99,
                        "title": 99
                    },
                    {
                        "id": 100,
                        "title": 100
                    },
                    {
                        "id": 101,
                        "title": 101
                    },
                    {
                        "id": 102,
                        "title": 102
                    },
                    {
                        "id": 103,
                        "title": 103
                    },
                    {
                        "id": 104,
                        "title": 104
                    },
                    {
                        "id": 105,
                        "title": 105
                    },
                    {
                        "id": 106,
                        "title": 106
                    },
                    {
                        "id": 107,
                        "title": 107
                    },
                    {
                        "id": 108,
                        "title": 108
                    },
                    {
                        "id": 109,
                        "title": 109
                    },
                    {
                        "id": 110,
                        "title": 110
                    },
                    {
                        "id": 111,
                        "title": 111
                    },
                    {
                        "id": 112,
                        "title": 112
                    },
                    {
                        "id": 113,
                        "title": 113
                    },
                    {
                        "id": 114,
                        "title": 114
                    },
                    {
                        "id": 115,
                        "title": 115
                    },
                    {
                        "id": 116,
                        "title": 116
                    },
                    {
                        "id": 117,
                        "title": 117
                    },
                    {
                        "id": 118,
                        "title": 118
                    },
                    {
                        "id": 119,
                        "title": 119
                    },
                    {
                        "id": 120,
                        "title": 120
                    },
                    {
                        "id": 121,
                        "title": 121
                    },
                    {
                        "id": 122,
                        "title": 122
                    },
                    {
                        "id": 123,
                        "title": 123
                    },
                    {
                        "id": 124,
                        "title": 124
                    },
                    {
                        "id": 125,
                        "title": 125
                    }
                ],
                "required": true
            },
            {
                "id": "changeAnchorPoints",
                "type": "switch",
                "title": "Change Anchor Points",
                "options": [
                    {
                        "id": "yes",
                        "title": "Yes"
                    },
                    {
                        "id": "no",
                        "title": "No"
                    }
                ],
                "required": false
            },
            {
                "id": "newUpperAnchor",
                "type": "dropdown",
                "title": "New Upper Anchor",
                "options": [
                    {
                        "id": "6000",
                        "title": "6000"
                    },
                    {
                        "id": "8000",
                        "title": "8000"
                    }
                ],
                "required": false
            },
            {
                "id": "newLowerAnchor",
                "type": "dropdown",
                "title": "New Lower Anchor",
                "options": [
                    {
                        "id": "500",
                        "title": "500"
                    },
                    {
                        "id": "1000",
                        "title": "1000"
                    },
                    {
                        "id": "2000",
                        "title": "2000"
                    }
                ],
                "required": false
            }
        ]
    }
]